import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, spacing } from "@mui/system";

import {
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import { DisplaySettingsOutlined, CloudUpload as MuiCloudUpload, PermDataSettingSharp, SettingsApplications } from "@mui/icons-material";
import useAuth from "../../hooks/useAuth";
import NotaFiscalConfigurationNFSE from "./nfse/dados-fiscais";
import MenuNotaFiscal from "./nfse/menuNfse";


const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

const FormControl = styled(MuiFormControl)(spacing);

const TextField = styled(MuiTextField)(spacing);

const Button = styled(MuiButton)(spacing);

const CloudUpload = styled(MuiCloudUpload)(spacing);

const CenteredContent = styled.div`
  text-align: center;
`;

const BigAvatar = styled(Avatar)`
  width: 350px;
  height: 120px;
  margin: 0 auto ${(props) => props.theme.spacing(2)};
`;




function NotaFiscalConfiguration() {

  const {  getApi  } = useAuth();
  const [menuId, setMenuId] = React.useState('nfse');
  const [nfConfiguration, setNfConfiguration] = React.useState();



  const loadConfig = async () => {
    let response = await getApi("/nf/configuration");
    setNfConfiguration(response.data);
  }

    useEffect(() => {
      loadConfig();
    
    }, []);


  return (
    <React.Fragment>
      <Helmet title="Portal do Cliente" />
      <Typography variant="h4" gutterBottom display="inline">
      Configuração
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} to="/">
          Dashboard
        </Link>
        <Link component={NavLink} to="/nota-fiscal/configuracao">
        Nota Fiscal
        </Link>
        <Typography>Configuração</Typography>
      </Breadcrumbs>

      <Divider my={2} />

      <Grid  container>
        <Grid item  sm={12} md={3}>
          <BottomNavigation
          showLabels
          value={menuId}
          onChange={(event, newValue) => {
            setMenuId(newValue);
          }}
        >
          <BottomNavigationAction label="Nota Fiscal de Serviço (NFs-e)" value={"nfse"} icon={<DisplaySettingsOutlined />} />
          <BottomNavigationAction label="Nota Fiscal ( NF-e ) - breve" icon={<DisplaySettingsOutlined />}  disabled={true}/>
        </BottomNavigation>
        </Grid>

      </Grid>
      <Divider my={2} />
        {menuId=='nfse' &&
        <MenuNotaFiscal nfConfiguration={nfConfiguration} loadConfig={loadConfig} />
        }

    </React.Fragment>
  );
}

export default NotaFiscalConfiguration;
